import { v4 as uuidv4 } from 'uuid';
import { getAvailableSchedulesAPI } from './api';

// Intermitten CORS issues affects the availableSchedules state, one real reason of the issue.
// to prevent it we limit the calls to availableSchedule per batch 2 at a time in, to prevent the preflight abused from happening.
export const AVAILABLE_SCHEDULES_CONCURRENCY = 2;

// Schedules use either .scheduleId or .id depending on the source shape
// (see openRemoveDialog in useSubscriptionDialogs.jsx for the same fallback).
function scheduleKey(schedule) {
    return schedule?.scheduleId ?? schedule?.id;
}

function dedupeSchedules(existing, incoming) {
    const byKey = new Map();
    [...existing, ...incoming].forEach((s) => {
        const key = scheduleKey(s);
        if (key != null) byKey.set(key, s);
    });
    return Array.from(byKey.values());
}

export function expandAvailableSchedules(subscriptionId) {
    this.availableSchedulesExpanded[subscriptionId] = true;
    this.observed.availableSchedulesExpanded = uuidv4();
}

export function closeAvailableSchedules(subscriptionId) {
    this.availableSchedulesExpanded[subscriptionId] = false;
    this.observed.availableSchedulesExpanded = uuidv4();
}

async function fetchAvailableSchedules(subscriptionId) {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.isLoadingCard[subscriptionId] = true;
    this.observed.isLoadingCard = uuidv4();
    this.env.startLoadCounter({ target: 'loadMoreSchedules' });

    try {
        const res = await getAvailableSchedulesAPI({ store: this, token: session.token, traceId, subscriptionId });

        if (res.error) return;

        // Can resolve after the user has since unsubscribed — skip the stale
        // write (pendingUnsubscribeIds, see unsubscribe.js).
        if (this.pendingUnsubscribeIds.has(subscriptionId)) return;

        if (Array.isArray(res?.data?.data)) {
            this.availableSchedules[subscriptionId] = dedupeSchedules(
                this.availableSchedules[subscriptionId] || [],
                res.data.data
            );
        } else {
            this.availableSchedules[subscriptionId] = this.availableSchedules[subscriptionId] || [];
        }

        this.availableSchedulesLoaded[subscriptionId] = this.availableSchedules[subscriptionId].length > 0;

        this.observed.availableSchedules = uuidv4();
        this.cardSignals.set(subscriptionId, uuidv4());
    } finally {
        delete this.isLoadingCard[subscriptionId];
        this.observed.isLoadingCard = uuidv4();
        this.env.stopLoadCounter();
    }
}

function laneFor(subscriptionId) {
    const key = String(subscriptionId);
    let hash = 0;
    for (let i = 0; i < key.length; i += 1) {
        hash = (hash * 31 + key.charCodeAt(i)) | 0;
    }
    return Math.abs(hash) % AVAILABLE_SCHEDULES_CONCURRENCY;
}

function getAvailableSchedules(subscriptionId) {
    const lane = laneFor(subscriptionId);

    const next = this.availableSchedulesQueues[lane]
        .then(() => fetchAvailableSchedules.call(this, subscriptionId))
        .catch(() => {});
    this.availableSchedulesQueues[lane] = next;
    return next;
}

export default getAvailableSchedules;
